import * as React from 'react';
import { CodeListBranch } from '../types-store';
import { CodetableTranslation } from '../../constants';

import styles from './number-of-results.scss';

interface NumberOfResultsProps {
  rootBranch: CodeListBranch;
  translation: CodetableTranslation;
}

export const NumberOfResults: React.FC<NumberOfResultsProps> = ({ rootBranch, translation }) => {

  if (!rootBranch || !rootBranch.items) {
    return null;
  }

  return <p className={styles.searchHits} id="code_number_of_results">
    {rootBranch.numberOfResults === 0
      ? translation.search_no_hits
      : `${rootBranch.numberOfResults} ${translation.search_hits}`}
  </p>;
};
